import { Component, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Component({
  selector: 'app-virtual-letters-keyboard',
  templateUrl: './virtual-letters-keyboard.component.html',
  styleUrls: ['./virtual-letters-keyboard.component.scss']
})
export class VirtualLettersKeyboardComponent {
  isUppercase = true;

  // QWERTY layout rows
  row1: string[] = ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'];
  row2: string[] = ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'];
  row3: string[] = ['Z', 'X', 'C', 'V', 'B', 'N', 'M'];

  // Events to emit
  @Output() keyPress = new EventEmitter<string>();
  @Output() clickedOutside = new EventEmitter<void>(); // Event for clicks outside

  constructor(private elementRef: ElementRef) {}

  /**
   * Emit the clicked key to the parent
   */
  onKeyPress(key: string): void {
    this.keyPress.emit(key);
  }

  /**
   * Toggle the case of the keyboard
   */
  toggleCase(): void {
    this.isUppercase = !this.isUppercase;

    if (this.isUppercase) {
      this.row1 = this.row1.map(key => key.toUpperCase());
      this.row2 = this.row2.map(key => key.toUpperCase());
      this.row3 = this.row3.map(key => key.toUpperCase());
    } else {
      this.row1 = this.row1.map(key => key.toLowerCase());
      this.row2 = this.row2.map(key => key.toLowerCase());
      this.row3 = this.row3.map(key => key.toLowerCase());
    }
  }

  /**
   * Listen to clicks on the document and emit the 'clickedOutside' event
   * if the click is outside the component
   */
  @HostListener('document:click', ['$event.target'])
  onClickOutside(targetElement: HTMLElement): void {
    const isClickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!isClickedInside) {
      this.clickedOutside.emit();
    }
  }
}
